import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search, PenTool, Hammer, Plug, Gauge, Rocket } from 'lucide-react';
import { Container, Reveal, SectionLabel } from './primitives';
import { PROCESS_STEPS } from './constants';

const ICONS = {
  discover: Search,
  design: PenTool,
  build: Hammer,
  integrate: Plug,
  optimize: Gauge,
  scale: Rocket,
};

export default function Process() {
  const { t } = useTranslation();

  return (
    <section id="process" className="bg-surface py-20 sm:py-28">
      <Container>
        <Reveal className="mx-auto max-w-2xl text-center">
          <SectionLabel>{t('home.process.eyebrow')}</SectionLabel>
          <h2 className="mt-5 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {t('home.process.title')}
          </h2>
          <p className="mt-4 text-lg text-white/55">{t('home.process.subtitle')}</p>
        </Reveal>

        <div className="relative mt-16">
          {/* Connecting line (desktop) */}
          <div className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-transparent via-accent/30 to-transparent lg:block" />

          <ol className="grid gap-8 sm:grid-cols-2 lg:grid-cols-6 lg:gap-4">
            {PROCESS_STEPS.map((step, i) => {
              const Icon = ICONS[step] || Search;
              return (
                <Reveal key={step} delay={i * 60} as="li" className="relative flex flex-col items-center text-center">
                  <span className="relative z-10 flex h-14 w-14 items-center justify-center rounded-2xl bg-accent-gradient text-white shadow-[0_8px_24px_rgba(109,74,255,0.4)]">
                    <Icon className="h-6 w-6" />
                  </span>
                  <span className="mt-2 text-xs font-bold text-accent-400">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <h3 className="mt-1 text-base font-semibold text-white">
                    {t(`home.process.steps.${step}.label`)}
                  </h3>
                  <p className="mt-1.5 text-sm text-white/50">
                    {t(`home.process.steps.${step}.description`)}
                  </p>
                </Reveal>
              );
            })}
          </ol>
        </div>
      </Container>
    </section>
  );
}
